export function renderPrivacy(): string {
  const updated = "March 8, 2026";
  return `
    <div class="legal-page">
      <div class="container" style="max-width: 720px; padding: 60px 20px;">
        <h1 style="font-size: 2rem; font-weight: 700; color: #111827; margin-bottom: 8px;">Privacy Policy</h1>
        <p style="color: #6b7280; margin-bottom: 48px;">Last updated: ${updated}</p>

        <div class="legal-section">
          <h2>1. Who we are</h2>
          <p>SideScribe ("we", "our", "us") is an AI-powered writing assistant for Microsoft Word, operated by the SideScribe team. Our website is <a href="https://sidescribe.ai">sidescribe.ai</a>. You can contact us at <a href="mailto:support@sidescribe.ai">support@sidescribe.ai</a>.</p>
        </div>

        <div class="legal-section">
          <h2>2. What we collect</h2>
          <p>We collect the minimum information necessary to provide the service:</p>
          <ul>
            <li><strong>Account information</strong> — your email address and password (managed by Firebase Authentication) when you create an account.</li>
            <li><strong>API keys</strong> — the OpenAI, Anthropic, or Google AI Studio API keys you enter in the dashboard or add-in. These are stored encrypted in your Firestore user record and are accessible only to you.</li>
            <li><strong>Usage data</strong> — your last-active timestamp and subscription status, used to manage your account.</li>
            <li><strong>Feedback</strong> — any messages you submit through the in-app feedback form.</li>
            <li><strong>Contact form submissions</strong> — if you fill out the enterprise contact form, we collect the information you provide (name, email, organization, message).</li>
          </ul>
        </div>

        <div class="legal-section">
          <h2>3. What we do not collect</h2>
          <ul>
            <li><strong>Document content</strong> — we never receive, store, or process the text from your Word documents. When you run a review, the selected text is sent <em>directly</em> from the Word add-in to your chosen AI provider (OpenAI, Anthropic, or Google) using your own API key. That text never passes through SideScribe servers.</li>
            <li><strong>Behavioral or tracking data</strong> — we do not use advertising trackers, fingerprinting, or third-party analytics that profile your behavior.</li>
          </ul>
        </div>

        <div class="legal-section">
          <h2>4. How we use your information</h2>
          <ul>
            <li>To authenticate you and manage your account.</li>
            <li>To provide and maintain the SideScribe service.</li>
            <li>To respond to your feedback or support requests.</li>
            <li>To send transactional emails (account verification, password reset). We do not send marketing email.</li>
          </ul>
        </div>

        <div class="legal-section">
          <h2>5. Third-party services</h2>
          <p>SideScribe relies on the following third-party services, each governed by their own privacy policies:</p>
          <ul>
            <li><strong>Firebase (Google)</strong> — authentication, database (Firestore), and hosting. <a href="https://firebase.google.com/support/privacy" target="_blank" rel="noopener">Firebase Privacy Policy</a></li>
            <li><strong>OpenAI</strong> — processes text you choose to review if you use OpenAI models. <a href="https://openai.com/policies/privacy-policy" target="_blank" rel="noopener">OpenAI Privacy Policy</a></li>
            <li><strong>Anthropic</strong> — processes text you choose to review if you use Claude models. <a href="https://www.anthropic.com/legal/privacy" target="_blank" rel="noopener">Anthropic Privacy Policy</a></li>
            <li><strong>Google AI Studio</strong> — processes text you choose to review if you use Gemini models. <a href="https://policies.google.com/privacy" target="_blank" rel="noopener">Google Privacy Policy</a></li>
          </ul>
          <p>Your API keys are sent to these providers solely to authenticate your requests. We do not share your personal information with any other third parties.</p>
        </div>

        <div class="legal-section">
          <h2>6. Data retention</h2>
          <p>We retain your account data for as long as your account is active. If you delete your account, we will delete your Firestore user record and associated data within 30 days. API keys are deleted immediately upon account deletion.</p>
        </div>

        <div class="legal-section">
          <h2>7. Security</h2>
          <p>We use Firebase Security Rules to ensure only you can read and write your own data. All data in transit uses TLS. API keys are stored in Firestore with field-level access controls.</p>
        </div>

        <div class="legal-section">
          <h2>8. Children's privacy</h2>
          <p>SideScribe is not directed at children under 13. We do not knowingly collect personal information from children under 13. If you believe a child has provided us personal information, please contact us and we will delete it.</p>
        </div>

        <div class="legal-section">
          <h2>9. Changes to this policy</h2>
          <p>We may update this policy occasionally. When we do, we will update the "Last updated" date at the top. Continued use of SideScribe after changes constitutes acceptance of the revised policy.</p>
        </div>

        <div class="legal-section">
          <h2>10. Contact</h2>
          <p>Questions about this policy? Email us at <a href="mailto:support@sidescribe.ai">support@sidescribe.ai</a>.</p>
        </div>
      </div>
    </div>
  `;
}

export function mountPrivacy(): void {
  // No dynamic behavior needed
}
